import { render, staticRenderFns } from "./site-header.vue?vue&type=template&id=4245ec71&scoped=true"
import script from "./site-header.vue?vue&type=script&lang=js"
export * from "./site-header.vue?vue&type=script&lang=js"
import style0 from "./site-header.vue?vue&type=style&index=0&id=4245ec71&prod&scoped=true&lang=css"
import style1 from "./site-header.vue?vue&type=style&index=1&id=4245ec71&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4245ec71",
  null
  
)

export default component.exports